
import {getOperatorDetalization} from '../api/getOperatorDetalization';
import {setGetOperatorDetalizationAction} from '../action';

const setGetOperatorDetalization = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getOperatorDetalization(params);
    
            if (data.status === 'success') {
                dispatch(setGetOperatorDetalizationAction(data.data));
            }
          
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetOperatorDetalization
}